/**
 * Created by Pankaj on 13-Nov-19
 */
import {BetLinesView, IBetLinesViewConfig} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {BetLineNumber} from "@nolimitcity/slot-game/bin/core/betline/BetLineNumber";
import {BetLine} from "@nolimitcity/slot-game/bin/core/betline/BetLine";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";


export class REBetLinesView extends BetLinesView{

    constructor(config:IBetLinesViewConfig,
                numberFactoryMethod:(index:number) => BetLineNumber,
                lineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => BetLine) {

        super(config, numberFactoryMethod, lineFactoryMethod);
    }

    /**
     * Override parent function to dispatch a event.
     */
    protected draw(): void {
        if (!this._resourcesLoaded || !this._dataInitialized) {
            return;
        }
        super.draw();
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.BET_LINES_DRAW_COMPLETED));
    }

}